import { render } from "./SimpleLayouts.vue?vue&type=template&id=030976ee&scoped=true"
const script = {}

import "./SimpleLayouts.vue?vue&type=style&index=0&id=030976ee&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-030976ee"]])

export default __exports__